import Microgame from '../engine/Microgame.js';

export default class FileGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Classe !`, en: `Sort!`, es: `¡Clasifica!` },
            controls: { fr: `Glisse les éléments vers le bon dossier`, en: `Swipe the items towards the correct folder`, es: `Desliza los elementos hacia la carpeta correcta` },
            objective: { fr: `Trie correctement les éléments`, en: `Sort the items correctly`, es: `Clasifica los elementos correctamente` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--secondary-color)" stroke-width="2"><path d="M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z"/></svg>`,
            actions: [
                { type: 'wait', duration: 260 },
                { type: 'swipe', fromX: 50, fromY: 80, toX: 50, toY: 32, duration: 760 },
                { type: 'wait', duration: 620 },
            ],
            loopDuration: 2800
        };
    }
    constructor(engine) {
        super(engine);
        this.doc = null;
        this.folderContainer = null;
        this.isDragging = false;
        this.startX = 0;
        this.startY = 0;
        this.docX = window.innerWidth / 2;
        this.docY = window.innerHeight * 0.75;
        this._isVictoryAnimating = false;
        this._frozenTimerValue = 0;

        // Difficulty scaling
        const speedMult = engine.speedMultiplier || 1.0;
        const adjustedSpeedScale = 1 + (speedMult - 1) * 0.4; 
        this.duration = 4000 * (speedMult / adjustedSpeedScale);
        this.folderPhase = 0;
    }

    setup() {
        this.engine.ui.instruction.textContent = "FILE IT!";

        // Folder area
        this.folderContainer = document.createElement('div');
        this.folderContainer.style.position = 'absolute';
        this.folderContainer.style.width = '180px';
        this.folderContainer.style.height = '130px';
        this.folderContainer.style.top = '30%';
        this.folderContainer.style.left = '50%';
        this.folderContainer.style.transform = 'translate(-50%, -50%)';
        this.container.appendChild(this.folderContainer);

        // Folder Back
        const folderBack = document.createElement('div');
        folderBack.style.position = 'absolute';
        folderBack.style.width = '100%';
        folderBack.style.height = '100%';
        folderBack.style.background = this.primaryColor;
        folderBack.style.borderRadius = '10px 40px 10px 10px';
        folderBack.style.border = `4px solid ${this.secondaryColor}`;
        folderBack.style.boxShadow = `0 0 20px ${this.primaryColor}`;
        this.folderContainer.appendChild(folderBack);

        // Document
        this.doc = document.createElement('div');
        this.doc.style.position = 'absolute';
        this.doc.style.width = '100px';
        this.doc.style.height = '140px';
        this.doc.style.background = 'rgba(0, 0, 0, 0.5)';
        this.doc.style.backdropFilter = 'blur(5px)';
        this.doc.style.border = `2px solid ${this.secondaryColor}`;
        this.doc.style.borderRadius = '5px';
        
        // Random starting position at the bottom of the container
        const startXRange = this.isPlayback ? 0 : ((Math.random() - 0.5) * 150);
        
        // Use relative positioning since the container is relatively positioned
        this.doc.style.left = `calc(50% + ${startXRange}px)`;
        this.doc.style.bottom = '10%'; // Keep it at the bottom
        this.doc.style.transform = `translate(-50%, 0) rotate(${this.isPlayback ? 0 : (Math.random() * 40 - 20)}deg)`;
        
        this.doc.style.cursor = 'grab';
        this.doc.style.boxShadow = '0 8px 20px rgba(0,0,0,0.6)';
        this.doc.style.touchAction = 'none';
        this.doc.style.zIndex = '5';
        
        // Document lines
        for(let i=0; i<4; i++) {
            const line = document.createElement('div');
            line.style.width = '70%';
            line.style.height = '8px';
            line.style.background = this.primaryColor;
            line.style.margin = '16px auto';
            line.style.borderRadius = '4px';
            this.doc.appendChild(line);
        }
        
        // Top Secret Stamp
        const stamp = document.createElement('div');
        stamp.style.position = 'absolute';
        stamp.style.bottom = '15px';
        stamp.style.right = '10px';
        stamp.style.color = this.secondaryColor;
        stamp.style.border = `2px solid ${this.secondaryColor}`;
        stamp.style.padding = '2px 5px';
        stamp.style.fontSize = '12px';
        stamp.style.fontWeight = '900';
        stamp.style.transform = 'rotate(-15deg)';
        stamp.textContent = 'SECRET';
        this.doc.appendChild(stamp);

        this.container.appendChild(this.doc);

        // Folder Front
        this.folderFront = document.createElement('div');
        this.folderFront.style.position = 'absolute';
        this.folderFront.style.width = '100%';
        this.folderFront.style.height = '85%';
        this.folderFront.style.bottom = '0';
        this.folderFront.style.background = this.secondaryColor;
        this.folderFront.style.borderRadius = '5px 5px 10px 10px';
        this.folderFront.style.border = `4px solid ${this.primaryColor}`;
        this.folderFront.style.zIndex = '10';
        this.folderFront.style.pointerEvents = 'none';
        this.folderFront.style.transformOrigin = 'bottom';
        this.folderFront.style.transition = 'transform 0.2s ease';
        this.folderFront.innerHTML = `<div style="text-align:center; margin-top: 15px; font-weight: 900; font-size: 14px; color: ${this.primaryColor};">TOP SECRET</div>`;
        this.folderContainer.appendChild(this.folderFront);

        // Events
        this.onDown = this.onDown.bind(this);
        this.onMove = this.onMove.bind(this);
        this.onUp = this.onUp.bind(this);

        this.doc.addEventListener('pointerdown', this.onDown);
        this.engine.input.element.addEventListener('pointermove', this.onMove);
        this.engine.input.element.addEventListener('pointerup', this.onUp);
    }

    update(dt) {
        if (this._isVictoryAnimating) {
            this.engine.timer = this._frozenTimerValue;
            return;
        }
        
        if (!this.active || this.won || this.lost) return;

        // Difficulty: folder moves left and right
        const speedMult = this.engine.speedMultiplier || 1.0;
        this.folderPhase += dt * 0.003 * speedMult;
        
        // Sway amplitude based on speed
        const amplitude = this.isPlayback ? 0 : (30 + (speedMult * 15)); 
        const offset = Math.sin(this.folderPhase) * amplitude;
        
        this.folderContainer.style.transform = `translate(calc(-50% + ${offset}px), -50%)`;
    }

    onDown(e) {
        if (!this.active || this.won || this.lost) return;
        this.isDragging = true;
        
        // Use container-relative coordinates to avoid overflow/cropping issues
        const rect = this.doc.getBoundingClientRect();
        const containerRect = this.container.getBoundingClientRect();
        
        // Find exact center of the document relative to the container
        this.docX = (rect.left + rect.width / 2) - containerRect.left;
        this.docY = (rect.top + rect.height / 2) - containerRect.top;
        
        // Switch to explicit px positioning instead of percentages for dragging
        this.doc.style.left = `${this.docX}px`;
        this.doc.style.top = `${this.docY}px`;
        this.doc.style.bottom = 'auto'; // Disable bottom rule
        
        this.startX = e.clientX;
        this.startY = e.clientY;
        
        this.doc.style.cursor = 'grabbing';
        this.doc.style.transform = `translate(-50%, -50%) rotate(0deg) scale(1.1)`;
        this.doc.style.transition = 'none'; // Remove any drop transition
    }

    onMove(e) {
        if (!this.isDragging || !this.active || this.won) return;
        
        // Calculate movement delta
        const dx = e.clientX - this.startX;
        const dy = e.clientY - this.startY;
        
        // Update document position
        this.docX += dx;
        this.docY += dy;
        
        this.doc.style.left = `${this.docX}px`;
        this.doc.style.top = `${this.docY}px`;
        
        // Reset start position for next move tick
        this.startX = e.clientX;
        this.startY = e.clientY;

        // Check if hovering folder (using container relative coordinates)
        const folderRect = this.folderContainer.getBoundingClientRect();
        const containerRect = this.container.getBoundingClientRect();
        
        const folderX = folderRect.left + folderRect.width / 2 - containerRect.left;
        const folderY = folderRect.top + folderRect.height / 2 - containerRect.top;
        
        if (Math.abs(this.docX - folderX) < 80 && Math.abs(this.docY - folderY) < 80) {
            this.folderFront.style.transform = 'scaleY(0.85)'; // Folder opens slightly
        } else {
            this.folderFront.style.transform = 'scaleY(1)';
        }
    }

    onUp(e) {
        if (!this.isDragging) return;
        this.isDragging = false;
        this.doc.style.cursor = 'grab';
        
        const folderRect = this.folderContainer.getBoundingClientRect();
        const containerRect = this.container.getBoundingClientRect();
        
        const folderX = folderRect.left + folderRect.width / 2 - containerRect.left;
        const folderY = folderRect.top + folderRect.height / 2 - containerRect.top;

        // Check if dropped near/in folder
        if (Math.abs(this.docX - folderX) < 60 && Math.abs(this.docY - folderY) < 80) {
            this.handleSuccess();
        } else {
            // Drop physics back
            this.doc.style.transition = 'transform 0.3s ease';
            this.doc.style.transform = `translate(-50%, -50%) rotate(${Math.random() * 40 - 20}deg) scale(1)`;
            this.folderFront.style.transform = 'scaleY(1)';
        }
    }

    handleSuccess() {
        if (this.won) return;
        this.won = true;
        this._isVictoryAnimating = true;
        this._frozenTimerValue = this.engine.timer;

        const folderRect = this.folderContainer.getBoundingClientRect();
        const containerRect = this.container.getBoundingClientRect();
        
        const centerX = (folderRect.left + folderRect.width / 2) - containerRect.left;
        const centerY = (folderRect.top + folderRect.height / 2) - containerRect.top;

        this.doc.style.transition = 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)';
        this.doc.style.left = `${centerX}px`;
        this.doc.style.top = `${centerY + 10}px`; 
        this.doc.style.transform = `translate(-50%, -50%) rotate(0deg) scale(0.6)`;
        this.doc.style.zIndex = '6'; // Slip between back and front of folder

        // Snap folder closed when doc goes in
        setTimeout(() => {
            this.folderFront.style.transform = 'scaleY(1)';
            this.folderFront.style.background = this.primaryColor;
            this.folderFront.style.border = `4px solid white`;
            this.folderContainer.style.boxShadow = `0 0 50px ${this.primaryColor}`;
            
            // Wait a tiny bit then win
            setTimeout(() => {
                this._isVictoryAnimating = false;
                this.win();
            }, 300);
        }, 300);
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('pointermove', this.onMove);
        this.engine.input.element.removeEventListener('pointerup', this.onUp);
    }
}
